import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React, { useContext } from 'react';
import { getComponentName } from './helpers';
export const MobileContext = /*#__PURE__*/ React.createContext(false);
MobileContext.displayName = 'MobileContext';
// HOC for convenience...
export function withMobileContext(Component) {
    const DecoratedComponent = (props)=>{
        const isMobile = useContext(MobileContext);
        return /*#__PURE__*/ React.createElement(Component, _object_spread({
            isMobile: isMobile
        }, props));
    };
    DecoratedComponent.displayName = `withMobileContext(${getComponentName(Component)})`;
    return DecoratedComponent;
}

//# sourceMappingURL=MobileContext.js.map